export default {
  meta: {
    title: '选址地图-收藏页',
    url: '/sitemap/collect', // 埋点字段，上报归属的模块
    urlName: '选址地图-收藏页' // 埋点字段，上报归属的模块
  }
};
